import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";

(pdfMake as any).vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const DesalfandegamentoDeclaracaoExclusividade = async (dados: any) => {

  const today = new Date();
  const dia = today.getDate();
  const mes = today.toLocaleString("pt-BR", { month: "long" });
  const ano = today.getFullYear();

  const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) =>
    res.blob()
  );
  const imageBase64 = (await getBase64Image(imageBlob)) as string;
  const imageConvert = await fetch("/img/logo/bg_fundo.png").then((res) =>
    res.blob()
  );
  const imageArmed = (await getBase64Image(imageConvert)) as string;

  const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
    <QRCodeSVG
      value={`https://armed.gov.ao/verifica-documento/certificado/${dados?.declaracao?._id}`}
      type="svg"
    />
  );

  const numeroCompleto = dados?.declaracao?.numeroDeclaracao || "";
  const [numeroDeclaracao, anoDeclarao] = numeroCompleto.split("/");

  const docDefinition: TDocumentDefinitions = {
    pageSize: "A4",
    pageMargins: [45, 10, 45, 100],

    content: [
      {
        columns: [
          {
            stack: [
              {
                svg: qrCodeSVG,
                width: 55,
                height: 55,
                margin: [0, 0, 0, 0],
              },
            ],
            alignment: "left",
            style: "header",
          },
          {
            image: imageBase64 as string,
          width: 60,
            height: 65,
            alignment: "center",
          },
          {
            text: "",
            width: "43%",
          },

        ],
        margin: [0, 40, 0, 5],
      },

      [
        { text: "REPÚBLICA DE ANGOLA", style: "header" },

        {
          columns: [
            { width: "*", text: "" },
            {
              width: 95,
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 0,
                  x2: 95,
                  y2: 0,
                  lineWidth: 1.8,
                  lineColor: "#FFBA00"
                }
              ]
            },
            { width: "*", text: "" }
          ],
          columnGap: 0,
          margin: [0, 2, 0, 0]
        },

        { text: "Ministério da Saúde", style: "subheader", margin: [0, -5, 0, 0] },
      ],

      {
        text: "Agência Reguladora de Medicamentos e Tecnologias de Saúde",
        style: "subheader2",
      },

      {
        text: [
          `DECLARAÇÃO DE EXCLUSIVIDADE `,
          {
            text: [
              `N.º`,
              {
                text: `${numeroDeclaracao}`,
                bold: true,
              },
              `/ARMED/${anoDeclarao}`,
            ],
            style: "declaracaoText",
            margin: [0, 0, 0, 10],
          },
        ],
        style: "declaracaoText",
        margin: [0, 30, 0, 0],
      },

      // Texto da declaração
      {
        text: [
          `Para devidos efeitos legais e administrativos, considerando o disposto na alínea o) do n.º 1 do artigo 12.º da Lei n.º 17/19, de 13 de Agosto, Lei que aprova o Código do IVA, conjugado com o n.º 6 e 7 da Circular n.º 014/DSAdu/DSIVA/AGT/20214, de 21 de Agosto, sobre a Interpretação dos Bens e Mercadorias Tributadas à Taxa Reduzida e Isentas do Imposto sobre o IVA nas Operações Internas e na Importação;`,
        ],
        style: "body",
        margin: [0, 10, 0, 5],
      },

      {
        text: [
          `A Agência Reguladora de Medicamentos e Tecnologias de Saúde (ARMED), Autoridade Reguladora do Sector Farmacêutico Angolano, declara que:`,
        ],
        style: "body",
        margin: [0, 10, 0, 5],
      },

      {
        text: [
          `A mercadoria constante na factura nº ${dados?.importador?.numFaturaPro}, cujo importador é a empresa ${dados?.importador?.nome}, `,
          ` com Autorização de Exercício Farmacêutico nº  ${dados?.importador?.numeroAutorizacao} e Declaração de Desalfandegamento nº ${numeroDeclaracao}/ARMED/2026, refere-se a produtos de saúde.`,
        ],
        style: "body",
        bold: true,
        margin: [0, 7, 0, 5],
        fontSize: 11,
      },
      // Texto adicional

      {
        text: [
          `E, por ser verdade e ter sido solicitada, foi passada a presente Declaração de Exclusividade, que vai assinada e autenticada com o carimbo a óleo em uso nesta Instituição Pública.`,
        ],
        style: "body",
        margin: [0, 5, 0, 5],
      },

      {
        text: [
          { text: `OBS.: `, bold: true },
          { text: ` A presente Declaração de Exclusividade destina-se à Administração Geral Tributária (AGT).`, style: "textObs" },
        ],
        style: "body",
        alignment: 'center',
        margin: [30, 15, 30, 15],
      },

      // Assinatura
      {
        text: [
          `AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE, EM LUANDA, AOS `,
          { text: `${dia}`, bold: true },
          ` DE `,
          { text: `${mes.toUpperCase()}`, bold: true },
          ` DE `,
          { text: `${ano}`, bold: true },
          `.`,
        ],
        alignment: "left",
        margin: [0, 10, 0, 5],
        fontSize: 10,
        style: "header",
      },
      {
        text: "O DIRECTOR GERAL",
        alignment: "center",
        style: "signature",
        margin: [0, 30, 0, 6],
      },
      {
        text: "DR. JOSÉ SOLINO JOEL",
        alignment: "center",
        style: "signature",
      },
    ],

    background: function (currentPage, pageSize) {
      return {
        image: imageArmed,
        width: pageSize.width,
        height: pageSize.height,
        absolutePosition: {
          x: 0,
          y: 0,
        },
        opacity: 1,
      };
    },

    /** ESTILOS DE DOCUMENTO **/
    styles: {
      header: {
        fontSize: 10,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      declaracaoText: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      subheader: {
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
      },
      subheader2: {
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        color: "#919191",
      },
      textObs: {
        color: "#0070C0",
      },
      declaration: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 0],
        decoration: "underline",
      },
      body: {
        fontSize: 11,
        alignment: "justify",
        margin: [0, 0, 0, 10],
        lineHeight: 1.3,
      },
      signature: {
        fontSize: 11,
        bold: true,
        margin: [0, 10, 0, 0],
      },
    },
    defaultStyle: {
      font: "Roboto",
    },
  };

  pdfMake.createPdf(docDefinition).open();
};

export { DesalfandegamentoDeclaracaoExclusividade };
